import { Locale } from '@silae/composables/i18n';

export const APP_NAVIGATION_WIDTH = 264;
export const APP_NAVIGATION_RAIL_WIDTH = 72;
export const APP_NAVIGATION_WIDTH_KEY = Symbol('APP_NAVIGATION_WIDTH_KEY');

export const APP_BAR_HEIGHT = 64; // TO BE UPDATED with related css token (cf: tokens.css)

export const SIDE_PANEL_WIDTH_DEFAULT = 380;
export const SIDE_PANEL_WIDTH_LG = 480;

export const DATE_CELL_DEFAULT_WIDTH = '165px';

export const ICON_CELL_DEFAULT_WIDTH = '32px'; // made for a 16px sized icon
export const ICON_SMALL = '16px';
export const ICON_MEDIUM = '24px';
export const ICON_LARGE = '32px';
export const ICON_X_LARGE = '48px';

export const MENU_OFFSET = '16px';

export const NOT_ASSIGNED = '-';

export const SPECIAL_CHARS_PATTERN = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

export const MINIMUM_PASSWORD_LENGTH = 16;

// this pattern is here to check that a user can't set his name to something that looks like an url with '://'
export const SECURED_USERNAME_PATTERN = /^((?!:\/\/).)*$/;

export const DEFAULT_LOCALE: Locale = {
	label: 'Français',
	value: 'fr'
};
